import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

export interface SplitView {
  managerQuestionGroupId?: number
  selfQuestionGroupId?: number
  canSeeSplitView: boolean
}

const correspondingGroupsForSplitView = (questionGroups: QuestionGroup[]) => {
  const managerQuestionGroups = questionGroups
    .filter((questionGroup) => {
      return questionGroup.respondentGroup?.get('name') === 'manager'
    })
    .sort((a, b) => (a.attributes.end_on > b.attributes.end_on ? 1 : -1))

  const selfReviewQuestionGroups = questionGroups
    .filter((questionGroup) => {
      return questionGroup.respondentGroup?.get('name') === 'self'
    })
    .sort((a, b) => (a.attributes.end_on > b.attributes.end_on ? 1 : -1))

  // Product decision: make the split view button show the latest 2
  // questionGroups belonging to manager and self respondent groups sorted by ends_on.
  if (managerQuestionGroups && selfReviewQuestionGroups) {
    return [
      managerQuestionGroups[managerQuestionGroups.length - 1],
      selfReviewQuestionGroups[selfReviewQuestionGroups.length - 1],
    ]
  }
}

export const useReviewsSplitViewData = (questionGroups: QuestionGroup[]): SplitView => {
  const groups = correspondingGroupsForSplitView(questionGroups)
  if (groups && groups.length === 2) {
    const managerQuestionGroup = groups.find(
      (group) => group?.respondentGroup?.get('name') === 'manager'
    )
    const selfQuestionGroup = groups.find((group) => group?.respondentGroup?.get('name') === 'self')

    if (managerQuestionGroup && selfQuestionGroup) {
      return {
        managerQuestionGroupId: managerQuestionGroup.get('id'),
        selfQuestionGroupId: selfQuestionGroup.get('id'),
        canSeeSplitView: true,
      }
    }
  }

  return {
    canSeeSplitView: false,
  }
}
